import type { TableReportType } from '~/types/report'
import type { ServiceScopeDimension } from '~/types/report-service'

export type QuickFilterKey = 'assetType' | 'site' | 'zone' | 'route' | 'group'

export const QUICK_FILTER_DIMENSIONS: Record<QuickFilterKey, ServiceScopeDimension> = {
  assetType: 'assetTypeIds',
  site: 'zoneIds',
  zone: 'zoneIds',
  route: 'routeIds',
  group: 'groupIds'
}

export interface ReportScopePreset {
  quickFilters: QuickFilterKey[]
  excludeGateways: boolean
  allowViews: boolean
  allowAdvanced: boolean
  singleAsset: boolean
}

const assetScopePreset = (quickFilters: QuickFilterKey[]): ReportScopePreset => ({
  quickFilters,
  excludeGateways: true,
  allowViews: true,
  allowAdvanced: true,
  singleAsset: false
})

const noScopePreset = (singleAsset: boolean): ReportScopePreset => ({
  quickFilters: [],
  excludeGateways: true,
  allowViews: false,
  allowAdvanced: false,
  singleAsset
})

export const REPORT_SCOPE_PRESETS: Record<TableReportType, ReportScopePreset> = {
  alert: assetScopePreset(['assetType', 'site', 'zone', 'group']),
  'assets-registry': assetScopePreset(['assetType', 'route', 'group']),
  'state-assets-log': assetScopePreset(['assetType', 'route', 'group']),
  usage: assetScopePreset(['assetType', 'route', 'group']),
  'user-log': noScopePreset(false)
}

export const getReportScopePreset = (reportType: TableReportType): ReportScopePreset => REPORT_SCOPE_PRESETS[reportType]

export const hasQuickFilter = (preset: ReportScopePreset, key: QuickFilterKey): boolean =>
  preset.quickFilters.includes(key)
